import * as d3 from 'd3';
import pako from 'pako';

/**
 * Retrieves the key associated with a given value in an object.
 *
 * @param {Object} object - The object to search through.
 * @param {any} value - The value to find the corresponding key for.
 * @returns {string|undefined} - The key associated with the given value, or undefined if not found.
 */
export function get_key_by_value(object, value) {
    for (let prop in object) {
        if (object.hasOwnProperty(prop)) {
            if (object[prop] === value)
                return prop;
        }
    }
}

/**
 * Asynchronously checks whether a file exists at the given path.
 * 
 * This function sends a `HEAD` request to the specified path and verifies the response.
 * Since some development servers (e.g., Parcel) may automatically redirect missing files 
 * to `index.html`, this function additionally checks the `Content-Type` header to avoid 
 * false positives.
 *
 * @param {string} path - The path to the file.
 * @returns {Promise<boolean>} - Resolves to `true` if the file exists, `false` otherwise.
 */
export async function check_file_exists(path) {
    const response = await fetch(path, { method: 'HEAD' });
    const contentType = response.headers.get('Content-Type');
    if (response.ok && contentType && !contentType.includes('text/html')) {
        return true; 
    }
    return false;
}

/**
 * Checks if a given value is a valid JSON string.
 *
 * @param {string} value - The string to be checked.
 * @returns {boolean} - Returns true if the string is valid JSON, otherwise false.
 */
export function is_valid_JSON(value) {
    try {
        JSON.parse(value);
        return true;
    } catch (e) {
        return false;
    }
}

export function update_update_time_display(update_time) {
    const update_time_p = document.getElementById("update_time");

    const update_time_title = document.createElement('span');
    update_time_title.setAttribute('data-i18n', 'update_time_title');
    update_time_title.textContent = '最後更新日期：';
    $(update_time_title).localize();

    const update_time_content = document.createElement('span');
    update_time_content.textContent = `${update_time}`;

    update_time_p.appendChild(update_time_title);
    update_time_p.appendChild(update_time_content);
}

export async function load_daily_stats_data(update_month) {
    const filepath = `dataset/stats_data/${update_month}/${update_month}.csv.gz`;

    const response = await fetch(filepath);
    const arrayBuffer = await response.arrayBuffer();
    const decompressed = pako.inflate(new Uint8Array(arrayBuffer), { to: 'string' });
    const data = d3.csvParse(decompressed);
    return data;
}

export async function load_tracking_data() {
    const filepath = `dataset/tracking_data/tracking_view.csv`;

    const response = await fetch(filepath);
    const data = d3.csvParse(await response.text());
    return data;
}
